// @flow
import React from 'react';
import type { Node } from 'react';
import Typography from '@material-ui/core/Typography';
import Box from "@material-ui/core/Box";

type Props = $ReadOnly<{
    title: Node,
    children: Node
}>;

function Section({ title, children }: Props) {
    return (
        <Box mb={3}>
            <Typography variant="h6">{title}</Typography>
            {children}
        </Box>
    );
}

export default Section;